import { RegisterCertificationClient } from 'front-office/view-models/register-certification-list';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';

export const headCells: HeadCell<RegisterCertificationClient, keyof RegisterCertificationClient>[] =
  [
    {
      id: 'type',
      label: 'Tipo registro',
    },
    {
      id: 'initials',
      label: 'Sigla registro',
    },
    {
      id: 'description',
      label: 'Desrizione registro',
    },
    {
      id: 'action',
      label: '',
    },
  ];

export const validationSchemaFilter = yup.object({});
